import React from 'react'
import { useHlsPlayerUI } from './HlsPlayerUIContext'

interface HlsTooltipProps {
  title: string
  subtitle?: string
}

/**
 * Tooltip shown on hover above control bar buttons.
 * Matches the Bitmovin UI tooltip styling: dark pill with title + subtitle,
 * positioned above the button with a downward-pointing arrow.
 *
 * Usage: Place inside a `group relative` parent button. The tooltip is hidden
 * by default and shown via the parent's `group-hover` state.
 *
 * Automatically hidden when the settings panel is open (reads `settingsOpen`
 * from HlsPlayerUIContext).
 */
export const HlsTooltip: React.FC<HlsTooltipProps> = ({ title, subtitle }) => {
  const { settingsOpen } = useHlsPlayerUI()

  if (settingsOpen) return null

  return (
    <div className="pointer-events-none absolute bottom-[calc(100%+16px)] right-[-8px] z-50 hidden flex-col gap-0.5 whitespace-nowrap rounded-lg bg-[rgba(28,28,28,0.95)] px-3.5 py-2.5 group-hover:flex">
      <span className="photon-caption-md font-semibold text-white">{title}</span>
      {subtitle && <span className="photon-caption-sm font-normal text-white/60">{subtitle}</span>}
      {/* Downward-pointing arrow */}
      <div className="absolute -bottom-[5px] right-[17px] h-2.5 w-2.5 rotate-45 rounded-br-sm bg-[rgba(28,28,28,0.9)]" />
    </div>
  )
}
